module.exports = __webpack_public_path__ + "img/NielsBohr.b4a1c412.jpg";